export const SET_TRANSFER_SUMMARY =
  "coinshift/newTransfer/SET_TRANSFER_SUMMARY";
export const SET_STEP = "coinshift/newTransfer/SET_STEP";
export const UPDATE_FORM = "coinshift/newTransfer/UPDATE_FORM";
export const RESET_TRANSFER_STORE =
  "coinshift/newTransfer/RESET_TRANSFER_STORE";
